import { Add } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import type { GridToolbarProps } from '@mui/x-data-grid-pro';
import { useIntl } from 'react-intl';

type ToolbarProps = GridToolbarProps & { onAddRow?: () => void };

export const RevenuesGridToolbar = (props: ToolbarProps) => {
  const { onAddRow } = props;
  const { formatMessage } = useIntl();
  const handleClick = () => {
    onAddRow?.();
  };

  return (
    <Box sx={{ p: 1, display: 'flex' }}>
      <Button color="primary" variant='text' startIcon={<Add />} onClick={handleClick}>
        {formatMessage({ id: 'Add rental unit' })}
      </Button>
    </Box>
  );
};